import React, { useState, useRef } from "react";

import { Input, InputNumber } from "antd";
import moment from "moment";

import DatePicker from "../DatePicker/DatePicker";

import "./StyledInput.css";

const StyledInput = ({
  className = "",
  type = "",
  datePickerData,
  ...restProps
}) => {
  const [originalDate, setOriginalDate] = useState("");
  const [datePickerDate, setDatePickerValue] = useState("");
  const datePickerRef = useRef();

  const isValidDateFormat = (inputValue) => {
    const { displayDateFormat } = datePickerData;
    if (!displayDateFormat) return true;

    const validFormat = moment(inputValue, displayDateFormat, true).isValid();
    if (!datePickerData.datePickerProps || (!datePickerData.datePickerProps.minDate && datePickerData.datePickerProps.maxDate)) {
      return validFormat;
    }

    /** Check date */
    const { minDate, maxDate } = datePickerData.datePickerProps;
    if (minDate && maxDate) {
      const validMinDate = moment(inputValue, displayDateFormat).isSameOrAfter(moment(minDate, displayDateFormat));
      const validMaxDate = moment(inputValue, displayDateFormat).isSameOrBefore(moment(maxDate, displayDateFormat));
      return validFormat && validMinDate && validMaxDate;
    }

    if (minDate) {
      const validMinDate = moment(inputValue, displayDateFormat).isSameOrAfter(moment(minDate, displayDateFormat));
      return validFormat && validMinDate;
    }

    if (maxDate) {
      const validMaxDate = moment(inputValue, displayDateFormat).isSameOrBefore(moment(maxDate, displayDateFormat));
      return validFormat && validMaxDate;
    }

    return validFormat;
  };

  const handleDateFocus = (e) => {
    const inputValue = e.target.value;
    const isValid = isValidDateFormat(inputValue);
    if (isValid) {
      setOriginalDate(inputValue);
      setDatePickerValue(inputValue);
    }
    if (datePickerRef.current?.open) {
      datePickerRef.current.open();
    }
  };

  const handleDateBlur = (e) => {
    const inputValue = e.target.value;
    const isValid = isValidDateFormat(inputValue);
    if (!isValid && inputValue) {
      datePickerData.resetDateValue(originalDate);
      setDatePickerValue(originalDate);
    } else {
      setDatePickerValue(inputValue);
    }
  };

  if (type === "number") {
    return (
      <InputNumber
        {...restProps} // eslint-disable-line
        className={`StyledInput ${className}`}
      />
    );
  }

  if (type === "textarea") {
    return (
      <Input.TextArea
        className={`StyledInput ${className}`}
        {...restProps} // eslint-disable-line
      />
    );
  }

  if (type === "datepicker") {
    return (
      <Input
        readOnly
        className={`StyledInput ${className}`}
        onFocus={handleDateFocus}
        onBlur={handleDateBlur}
        suffix={(
          <DatePicker
            ref={datePickerRef}
            value={datePickerDate}
            prevValue={datePickerDate}
            {...datePickerData.datePickerProps} // eslint-disable-line
          />
        )}
        {...restProps} // eslint-disable-line
      />
    );
  }

  return (
    <Input
      className={`StyledInput ${className}`}
      {...restProps} // eslint-disable-line
    />
  );
};

export default StyledInput;
